import React, { Component } from 'react';
import SwipeableViews from 'react-swipeable-views';
import { PaddedSection } from '../../atoms';
import { PriceCard } from '../../molecules';

import './styles.css';

const MQ_SMALL_SCREEN = '(max-width: 1024px)';

/**
 * A template for the price section of the landing page.
 *
 * @typedef {Object} Props
 * @prop {String} heading
 * @prop {object[]} priceOptions
 *
 * @augments {Component<Props>}
 */
export default class PriceCards extends Component {

	state = {
		isSmallScreen: window.matchMedia(MQ_SMALL_SCREEN).matches,
	};

	componentDidMount () {
		this.mql = window.matchMedia(MQ_SMALL_SCREEN);
		this.mql.addListener(this.handleMediaChange);
	}

	componentWillUnmount () {
		this.mql.removeListener(this.handleMediaChange);
	}

	genPriceCards = (priceOptions = []) =>
		priceOptions.map((props) => (
			<div key={props.heading} className='PriceCards-wrapper'>
				<PriceCard {...props} />
			</div>
		));

	handleMediaChange = ({ matches }) => {
		this.setState({
			isSmallScreen: !!matches,
		});
	}

	render () {
		const { heading, priceOptions } = this.props;
		const priceCards = this.genPriceCards(priceOptions);

		return (
			<PaddedSection className='PriceCards'>
				<h1>{heading}</h1>
				<section className='PriceCards-contentWrapper'>
					{this.state.isSmallScreen
						// @ts-ignore
						? <SwipeableViews
							enableMouseEvents
							resistance
						>
							{priceCards}
						</SwipeableViews>
						: priceCards
					}
				</section>
			</PaddedSection>
		);
	}

}



// WEBPACK FOOTER //
// ./src/components/templates/PriceCards/PriceCards.js